module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Cover#cover",
      "id": "rcover"
    }
  }, [_c('i', [_vm._v("       Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Titlepage#title",
      "id": "rtitle"
    }
  }, [_c('i', [_vm._v("       Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Dedication#_idParaDest-1",
      "id": "r_idParaDest-1"
    }
  }, [_c('i', [_vm._v("       Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/9780062471123_Contents"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }, [_c('i', [_vm._v("       Contents")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Preface#_idParaDest-3",
      "id": "r_idParaDest-3"
    }
  }, [_c('i', [_vm._v("       Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Introduction#_idParaDest-4",
      "id": "r_idParaDest-4"
    }
  }, [_vm._v("       Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_1#_idParaDest-5",
      "id": "r_idParaDest-5"
    }
  }, [_vm._v("  1.  The Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_2#_idParaDest-7",
      "id": "r_idParaDest-7"
    }
  }, [_vm._v("  2.  Debs’ Delight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_3#_idParaDest-9",
      "id": "r_idParaDest-9"
    }
  }, [_vm._v("  3.  Medals Not Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_4#_idParaDest-11",
      "id": "r_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4.  History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_5#_idParaDest-13",
      "id": "r_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5.  The Foundation Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_6#_idParaDest-15",
      "id": "r_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6.  The Stuffed Stoat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_7#_idParaDest-17",
      "id": "r_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7.  Swinging Sixties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_8#_idParaDest-19",
      "id": "r_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8.  Mrs PB")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_9#_idParaDest-21",
      "id": "r_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9.  The Attentions of a Prince")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_10#_idParaDest-23",
      "id": "r_idParaDest-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.  An Education")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_11#_idParaDest-25",
      "id": "r_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.  A Suitable Bride")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_12#_idParaDest-27",
      "id": "r_idParaDest-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.  Dishonesty All Round")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_13#_idParaDest-29",
      "id": "r_idParaDest-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.  A State of Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_14#_idParaDest-31",
      "id": "r_idParaDest-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.  The Stuff of Nightmares")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_15#_idParaDest-33",
      "id": "r_idParaDest-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.  Princess of Wales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_16#_idParaDest-35",
      "id": "r_idParaDest-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.  A Plea for Help")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_17#_idParaDest-37",
      "id": "r_idParaDest-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.  For King and Country")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_18#_idParaDest-39",
      "id": "r_idParaDest-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.  Annus Horribilis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_19#_idParaDest-41",
      "id": "r_idParaDest-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.  The Final Salvos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_20#_idParaDest-43",
      "id": "r_idParaDest-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.  Dark Days")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_21#_idParaDest-45",
      "id": "r_idParaDest-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.  Divorce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_22#_idParaDest-47",
      "id": "r_idParaDest-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.  Blackadder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_23#_idParaDest-49",
      "id": "r_idParaDest-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.  Week of Waiting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_24#_idParaDest-51",
      "id": "r_idParaDest-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.  A Low Profile")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_25#_idParaDest-53",
      "id": "r_idParaDest-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.  Raw Recruit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_26#_idParaDest-55",
      "id": "r_idParaDest-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.  Coming Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_27#_idParaDest-57",
      "id": "r_idParaDest-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.  A Little Local Difficulty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_28#_idParaDest-59",
      "id": "r_idParaDest-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.  U-Turn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_29#_idParaDest-61",
      "id": "r_idParaDest-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.  Final Furlong")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_30#_idParaDest-63",
      "id": "r_idParaDest-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.  It Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_31#_idParaDest-65",
      "id": "r_idParaDest-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.  Staying Sane")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_32#_idParaDest-67",
      "id": "r_idParaDest-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.  Pillars of Interest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_33#_idParaDest-69",
      "id": "r_idParaDest-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.  A Good Read")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_34#_idParaDest-71",
      "id": "r_idParaDest-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.  Nothing to Prove")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_35#_idParaDest-73",
      "id": "r_idParaDest-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.  In the Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_36#_idParaDest-75",
      "id": "r_idParaDest-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.  Bedside Manner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_37#_idParaDest-77",
      "id": "r_idParaDest-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.  Abroad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_38#_idParaDest-79",
      "id": "r_idParaDest-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.  WOW")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_39#_idParaDest-81",
      "id": "r_idParaDest-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39.  Making a Difference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_40#_idParaDest-83",
      "id": "r_idParaDest-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40.  Domestic Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_41#_idParaDest-85",
      "id": "r_idParaDest-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41.  Mending Fences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Chapter_42#_idParaDest-87",
      "id": "r_idParaDest-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42.  The Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Acknowledgements#_idParaDest-91",
      "id": "r_idParaDest-91",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Bibliography#_idParaDest-89",
      "id": "r_idParaDest-89",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Index#_idParaDest-92",
      "id": "r_idParaDest-92",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Picture_Credits#_idParaDest-90",
      "id": "r_idParaDest-90",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       Photo Section")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-93",
      "id": "r_idParaDest-93",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Also_by_Penny_Junor#_idParaDest-94",
      "id": "r_idParaDest-94",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       Also by Penny Junor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062471123_Copyright#_idParaDest-96",
      "id": "r_idParaDest-96",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-97",
      "id": "r_idParaDest-97",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("       About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602fa7bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062471123_Contents.vue
// module id = 66
// module chunks = 0